<app-card-layout-content class="session-expired">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <app-feedback-failure-svg-icon></app-feedback-failure-svg-icon>
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Sessione scaduta</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <p class="session-expired__description" i18n>Non è stato possibile procedere.</p>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
  <button
    class="session-expired__button p-fluid p-mt-auto"
    label="Torna alla login"
    i18n-label
    pButton
    (click)="onLoginButtonClick()"
  ></button>
</app-card-layout-content>
